export default __webpack_public_path__ + "static/media/bug.38b842d8.svg";